import LegacyAegis from '@tencent/aegis-web-sdk';
import GalileoAegis from '@tencent/aegis-web-sdk-v2';
import { env as currentEnv } from '@/env/current';
import { getRequestBaseURL } from '@/request/standalone-base-url';
import {
  buildTraceApiConfig,
  filterGalileoLogs,
  filterLegacyRequest,
  getAegisEnv,
  handleApiResponse,
  isGalileoTraceEnabled,
  MONITORING_ENDPOINT_PATTERNS,
} from './aegis-policy';
import {
  createGalileoMonitoringSink,
  createLegacyMonitoringSink,
  createMonitoringReporter,
} from './aegis-reporter';

const releaseVersion = Array.from(document.getElementsByTagName('meta'))
  .find(element => element.name === 'x-release-id')
  ?.getAttribute('content') || undefined;

// 监控需早于登录态加载，用户身份在登录完成后通过 setMonitoringUser 补充。
const legacyAegis = new LegacyAegis({
  id: 'okaqLTbv2kgaX7JXyo',
  reportApiSpeed: true,
  reportAssetSpeed: true,
  spa: true,
  hostUrl: 'https://rumt-sg.com',
  env: getAegisEnv(currentEnv.deployEnv),
  beforeRequest: filterLegacyRequest,
  api: {
    apiDetail: true,
    retCodeHandler: handleApiResponse,
  },
  speedSample: false, // 测速不抽样，保持迁移前统计口径。
  version: releaseVersion,
});

const traceConfig = buildTraceApiConfig(
  isGalileoTraceEnabled(import.meta.env.VITE_GALILEO_TRACE_ENABLED),
  getRequestBaseURL(),
);

const galileoAegis = new GalileoAegis({
  id: 'SDK-540800bc78eba6997056',
  hostUrl: { url: 'https://tgalileo.com/collect' },
  env: getAegisEnv(currentEnv.deployEnv),
  version: releaseVersion,
  extField: {
    bizPlatform: currentEnv.bizPlatform,
  },
  repeat: 100,
  plugin: {
    pv: true,
    aid: true,
    error: true,
    device: true,
    close: true,
    pagePerformance: true,
    webVitals: true,
    fId: true,
    spa: true,
    api: {
      apiDetail: true,
      retCodeHandler: handleApiResponse,
      ignoreUrls: [...MONITORING_ENDPOINT_PATTERNS],
      ...traceConfig,
    },
    apiSpeed: true,
    assetSpeed: true,
    session: true,
    blankScreen: false,
  },
  onBeforeSend: filterGalileoLogs,
});

export const aegis = createMonitoringReporter([
  createLegacyMonitoringSink(legacyAegis),
  createGalileoMonitoringSink(galileoAegis),
]);

export function setMonitoringUser(userName: string): void {
  aegis.setUser(userName);
}

window.aegis = aegis;
